import React, { Component, Fragment } from 'react';
import TestimonialSlide from './TestimonialSlide.js';
import Slider from '../../common/Slider.js';
import testimonials from './testimonials-info.js';

class Testimonials extends Component {
  
  render() {
    return (
      <Fragment>
        <h1>Testimonials</h1>
        <Slider length={testimonials.length} autoSlide={true}>
          {testimonials.map((info, i) => 
            <TestimonialSlide
              {...info}
              key={i}
              handleTouchStart={this.props.handleTouchStart}
              handleTouchEnd={this.props.handleTouchEnd}
            />
          )}
        </Slider>
      </Fragment>
    );
  }
}

export default Testimonials;
